<div>
    <span class="text-info clickeable" tooltip="Ver Detalles del Lote" (click)="viewBatch()">
        <i class="fa fa-eye" *ngIf="!loading"></i>
        <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loading"></span>
    </span>
</div>

<app-modal-dialog [show]="showModal" (closed)="closeModalEmit()"  size="xl" position="top" #modal>
    <div class="modal-header" modal-header>
        <h3>Detalle de Lote</h3>
        <h4 class="i-hover ml-4">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h4>
    </div>
    <div class="modal-body" modal-body *ngIf="batchData!=null">
        <ng-container *ngFor="let batch of batchData.batchTransaction">
            <div class="row border border-1 py-4">
                <div class="row mb-4">
                    <div class="col-sm-6">
                        Tipo de Transaccion: 
                        <span class="font-bold" *ngIf="batch.batchType=='ACH_CREDIT_TRANSFER'">ACH a otros bancos</span>
                        <span class="font-bold" *ngIf="batch.batchType=='THIRD_BAM'">Propias y de Terceros</span>
                        <span class="font-bold" *ngIf="batch.batchType=='PAYROLL_PAYMENT'">Pago de Planilla</span>
                        <span class="font-bold" *ngIf="batch.batchType=='TAX_PAYMENT'">Pago de Impuestos</span>
                        <span class="font-bold" *ngIf="batch.batchType=='CREDIT_CARD'">Pago de Tarjeta de Crédito</span>
                        <span class="font-bold" *ngIf="batch.batchType=='LOAN_PAYMENT'">Pago de Prestamo</span>
                        <span class="font-bold" *ngIf="batch.batchType=='SERVICE_PAYMENT'">Pago de Servicios</span>
                    </div>
                    <div class="col-sm-6">
                        Fecha: <span class="font-bold" >{{batchData.date | date:'dd-MM-YYYY HH:mm'}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 mb-3">
                        No. Voucher: <span class="font-bold" >{{batch.transactionDetail[0].voucherId}}</span>
                        <div *ngIf="batch.transactionDetail[0].voucherId!=0">
                            <span class="text-info clickeable" tooltip="Recibo" (click)="getReceipts(batch.batchTransaction, batchData.date, batchData.date, batch.transactionDetail[0].voucherId)">
                                <i class="fa fa-file-invoice" *ngIf="!loadingVoucher"></i>
                                <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingVoucher"></span>
                            </span>
                        </div>
                    </div>
                    <div class="col-sm-6 mb-3">
                        <div *ngIf="status(batch.status)" class="d-flex align-items-center gap-2">
                            
                            <!-- Badge -->
                            <span class="badge bg-primary">
                                {{ status(batch.status).name }}
                            </span>

                            <!-- Description -->
                            <span class="text-muted">
                                {{ status(batch.status).description }}
                            </span>

                            </div>

                            <div *ngIf="!status(batch.status)">
                            <span class="text-danger">Estado desconocido</span>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        Cuenta Origen: <span class="font-bold" >{{batch.originAccount}}</span>
                    </div>
                    <div class="col-sm-6">
                        Monto: <span class="font-bold" >{{batch.batchAmount}} {{batch.origingAccountCurrency}}</span>
                    </div>
                    <div class="col-sm-6">
                        Cuenta Destino: <span class="font-bold" >{{batch.transactionDetail[0].destinationAccount}}</span>
                    </div>
                    <div class="col-sm-6">
                        Nombre Destinatario: <span class="font-bold" >{{batch.transactionDetail[0].destinationHolderName}}</span>
                    </div>
                    <div class="col-sm-6">
                        Referencia: <span class="font-bold" >{{batch.transactionDetail[0].reference}}</span>
                    </div>
                    <div class="col-sm-6">
                        Concepto: <span class="font-bold" >{{batch.transactionDetail[0].descriptionTransaction}}</span>
                    </div>
                    <div class="col-sm-6" *ngIf="batch.transactionDetail[0].status == 'FAILED'">
                        Mensaje: <span class="font-bold" >{{batch.transactionDetail[0].statusMsg}}</span>
                    </div>
                    
                </div>
            </div>

        </ng-container>

        <ng-container *ngIf="!batchData.batchTransaction || batchData.batchTransaction.length==0" >
            <div class="row border border-1 py-4" *ngFor="let batch of batchData.transactionReceived">
                Transaccion Recibida
                <div class="row mb-4">
                    <div class="col-sm-6">
                        Tipo de Transaccion: 
                        <span class="font-bold" *ngIf="batch.batchType=='ACH_CREDIT_TRANSFER'">ACH a otros bancos</span>
                        <span class="font-bold" *ngIf="batch.batchType=='THIRD_BAM'">Propias y de Terceros</span>
                        <span class="font-bold" *ngIf="batch.batchType=='PAYROLL_PAYMENT'">Pago de Planilla</span>
                        <span class="font-bold" *ngIf="batch.batchType=='TAX_PAYMENT'">Pago de Impuestos</span>
                        <span class="font-bold" *ngIf="batch.batchType=='CREDIT_CARD'">Pago de Tarjeta de Crédito</span>
                        <span class="font-bold" *ngIf="batch.batchType=='LOAN_PAYMENT'">Pago de Prestamo</span>
                        <span class="font-bold" *ngIf="batch.batchType=='SERVICE_PAYMENT'">Pago de Servicios</span>
                    </div>
                    <div class="col-sm-6">
                        Fecha: <span class="font-bold" >{{batchData.date |  date:'dd-MM-YYYY HH:mm'}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6 mb-3">
                        Error: <span class="font-bold" >{{batch.validation? batch.validation[0] : "Sin Errores"}}</span>
                    </div>
                    <div class="col-sm-6 mb-3">
                        <div *ngIf="status(batch.statusBatch)" class="d-flex align-items-center gap-2">
                            
                            <!-- Badge -->
                            <span class="badge bg-primary">
                                {{ status(batch.statusBatch).name }}
                            </span>

                            <!-- Description -->
                            <span class="text-muted">
                                {{ status(batch.statusBatch).description }}
                            </span>

                            </div>

                            <div *ngIf="!status(batch.statusBatch)">
                            <span class="text-danger">Estado desconocido</span>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        Cuenta Origen: <span class="font-bold" >{{batch.originAccount.accountNumber}}</span>
                    </div>
                    <div class="col-sm-6">
                        Monto: <span class="font-bold" >{{batch.transferInfo.transactionAmount}} {{batch.originAccount.currency}}</span>
                    </div>
                    <div class="col-sm-6">
                        Cuenta Destino: <span class="font-bold" >{{batch.destinationAccount.accountNumber}}</span>
                    </div>
                    <div class="col-sm-6">
                        Referencia: <span class="font-bold" >{{batch.transferInfo.reference}}</span>
                    </div>
                    <div class="col-sm-6">
                        Concepto: <span class="font-bold" >{{batch.transferInfo.concept}}</span>
                    </div>
                    
                </div>
            </div>

        </ng-container>
    </div>
</app-modal-dialog>